module.exports = "<div class=\"jumbotron\">\n  <h1>\n    Page not found\n  </h1>\n  <i class=\"material-icons md-192 text-danger\">warning</i>   \n  <h2>page you are looking for is not longer avaiable!</h2>\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/components/not-found/not-found.component.html
// module id = ../../../../../src/app/components/not-found/not-found.component.html
// module chunks = main